import {useMutation, useQuery} from '@tanstack/react-query';
import {
  addRedactionTag,
  deleteRedactionTag,
  editRedactionTag,
  getRedactionTagsList,
  getRedactionViewData,
} from '../../api/endpoints/redactionApi';
import {
  IAddEditRedactionTagRequest,
  IAddEditRedactionTagResponse,
  IGetRedactionTagsList,
  IGetRedactionViewDataResponse,
} from '../../api/types/redactions.type';

export const useGetRedactionViewData = () => {
  return useQuery<IGetRedactionViewDataResponse, Error>({
    queryKey: ['getRedactionViewData'],
    queryFn: () => getRedactionViewData(),
  });
};

export const useGetRedactionTagsList = (params: string, enabled: boolean) => {
  return useQuery<Array<IGetRedactionTagsList>, Error>({
    queryKey: ['getRedactionTagsList', params],
    queryFn: () => getRedactionTagsList(params),
    enabled,
  });
};

export const useAddRedactionTag = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    IAddEditRedactionTagResponse,
    Error,
    IAddEditRedactionTagRequest
  >({
    mutationKey: ['addRedactionTag'],
    mutationFn: addRedactionTag,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useEditRedactionTag = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    IAddEditRedactionTagResponse,
    Error,
    {payload: IAddEditRedactionTagRequest; tagId: number}
  >({
    mutationKey: ['editRedactionTag'],
    mutationFn: editRedactionTag,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useDeleteRedactionTag = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<IAddEditRedactionTagResponse, Error, number>({
    mutationKey: ['deleteRedactionTag'],
    mutationFn: deleteRedactionTag,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
